import React, { useState } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
// import SignUpPhase2 from "./SignUpPhase2";
import Body from "./Body";
import "../Components/css/loggin.css";
// import "../Components/css/Phase3.css";
// import "../Components/css/responsive.css";
import { AiFillPhone } from "react-icons/ai";
import { BsFillPersonFill } from "react-icons/bs";
import { FaMale, FaFemale, FaAddressBook } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { doc, updateDoc } from "firebase/firestore";
import { db, auth } from "./FireBaseConfig";
import { toast } from "react-toastify";

const SignupPhase3 = () => {

  
  const [data, setData] = useState({
    phone: "",
    address: "",
    postalCode: "",
  });

  const { phone, address, postalCode } = data;

  let { uid } = auth.currentUser;
  console.log(uid);
  let navigate = useNavigate();

  const valuesChange = (event) => {
    setData({
      ...data,
      [event.target.name]: event.target.value,
    });
  };

  const SaveData = async (e) => {
    e.preventDefault();
    if (phone !== "" && address !== "" && postalCode !== "") {
      try {
        let res = await updateDoc(doc(db, "users", uid), {
          phone,
          address,
          postalCode,
        });
        navigate("/Dashboard");
        console.log(res);
      } catch (error) {
        console.log(error);
      }
    } else if (phone == "" && address == "" && postalCode == "") {
      toast.error("Please Enter Feild!!");
    }
  };
  return (
    <>
      <Navbar />
      <div className="main-containerr bgclr">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-6 col-lg-7">
              <Body />
            </div>
            <div className="col-12 col-sm-12 col-md-6 col-lg-5">
              <div className="main-form mt-2">
                <div>
                  <div className="Info text-white">
                    <h3 className=" text-white mb-3">RAFFLE MANIA</h3>
                    <p>Sign Up</p>

                    <form className="formInputs mt-2">
                      <label for="email">PHONE</label>
                      <div className="form-group d-flex">
                        <input
                          type="text"
                          className="text-white"
                          id="email"
                          placeholder="Enter Phone Number"
                          value={phone}
                          onChange={valuesChange}
                          name="phone"
                        />
                        <div class="input-group-append">
                          <span class="input-group-text">
                            <AiFillPhone />
                          </span>
                        </div>
                      </div>
                      <label for="email">ADDRESS</label>
                      <div className="form-group d-flex">
                        <input
                          type="text"
                          className="text-white"
                          placeholder="Enter Address"
                          id="email"
                          value={address}
                          onChange={valuesChange}
                          name="address"
                        />
                        <div class="input-group-append">
                          <span class="input-group-text">
                            <FaAddressBook />
                          </span>
                        </div>
                      </div>

                      <label for="pwd">POSTAL CODE</label>
                      <div className="form-group d-flex">
                        <input
                          type="text"
                          className=""
                          placeholder="Enter Postal Code"
                          id="pwd"
                          value={postalCode}
                          onChange={valuesChange}
                          name="postalCode"
                        />
                        <div class="input-group-append">
                          <span class="input-group-text">
                            <BsFillPersonFill />
                          </span>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <div className=" btnDiv pl-4 pr-3">
                  <div className="d-flex justify-content-between">
                    <button
                      className="btn w-50  m-1 bg-white  signBtn2"
                      onClick={() => {
                        navigate(`/SignUpPhase2`);
                      }}
                    >
                      Previous
                    </button>
                    <button
                      className="btn   w-50  m-1 mr-5 bg-white signBtn2"
                      onClick={SaveData}
                    >
                      Next
                    </button>
                  </div>

                  <p className="text-white p-3">
                    Already Have an Account?
                    <span>
                      <a
                        className="text-primary"
                        onClick={() => {
                          navigate(`/`);
                        }}
                      >
                        Log In
                      </a>
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default SignupPhase3;
